import React from "react"
import LoanCommissionCard from "./Card"
import ManageLoanCommission from './ManageItem'

export default function LoanCommissionDetails({ params }) {

  return <ManageLoanCommission
    params={ params }
    callback={ data => <LoanCommissionCard loanCommission={ data } /> }
  />
}



// WEBPACK FOOTER //
// ./src/components/Accounting/LoanCommission/Details.js